import React from "react";
import Layout from "../../layout/Layout";
import TerminalTemplate from "../../templates/terminal-template/Main";
import { useSeoData } from "../../templates/seo/Main";

const Terminal1 = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Terminal 1"}>
      <TerminalTemplate keyword={"Terminal-1"} />
    </Layout>
  );
};

export default Terminal1;

export const Head = () => {
  const { meta_title, meta_description, meta_keyword } = useSeoData("terminal-1");
  return (
    <>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description?.data?.meta_description} />
      <meta name="keywords" content={meta_keyword?.data?.meta_keyword} />
    </>
  );
};
